export enum ActionTemplateScreen {
  BOTH = "Both",
  DEPOT_OUT = "DepotOut",
  DEPOT_IN = "DepotIn",
}